(() => {
    if (!window.productViewerConfig) {
        return;
    }
    const STORAGE_KEY = 'up_live_viewer_session';

    // The server/Durable Object controls the 14/25/30-day (product-view retention period.)
    function getSessionId() {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored) {
                const session = JSON.parse(stored);
                if (session && session.id) {
                    return session.id;
                }
            }

        } catch (error) {
            console.warn(
                'Invalid viewer session found. Creating a new one.'
            );
        }

        const session = {
            id: 'UP_' + crypto.randomUUID(),
            createdAt: Date.now()
        };

        try {
            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify(session)
            );
        } catch (error) {
            console.warn(
                'Unable to save viewer session.',
                error
            );
        }
        return session.id;
    }

    async function updateViewer() {
        // console.log('updateViewer called');
        try {
            const response = await fetch(
                window.productViewerConfig.endpoint,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        productId: window.productViewerConfig.productId,
                        sessionId: getSessionId()
                    })
                }
            );
            // console.log('response :::::::::', response);
            if (!response.ok) {
                const errorText = await response.text();
                console.error(
                    'Viewer API error:',
                    response.status,
                    errorText
                );
                throw new Error(
                    `Viewer API failed: ${response.status} - ${errorText}`
                );
            }
            const data = await response.json();
            const container = document.getElementById('product-live-viewers');
            const counter = document.getElementById('viewer-count');
            if (!container || !counter || !data.success) {
                return;
            }

            const viewers = Number(data.viewers) || 0;
            // Update number
            counter.textContent = viewers.toLocaleString();
            // Show the viewer message.
            container.classList.remove('hidden');

            // Rebuild the message around the existing counter so
            // #viewer-count stays in the DOM for the next heartbeat.
            const message = document.getElementById('viewer-message');
            if (message) {
                const isPopular = viewers > 500;
                const label = document.createElement('strong');
                label.textContent = isPopular ? 'Popular right now ' : 'Frequently viewed ';
                const suffix = isPopular ? ' Homeowners are viewing this product' : ' recent views';

                const paragraph = document.createElement('p');
                paragraph.append(label, counter, suffix);
                message.replaceChildren(paragraph);
            }
        } catch (error) {
            console.error(
                'Product viewer error:',
                error
            );
        }
    }


    let heartbeat = null;
    function startHeartbeat() {
        if (heartbeat) {
            return;
        }
        // Immediately register/view product.
        updateViewer();

        //  Continue checking every 60 seconds.
        heartbeat = setInterval(
            updateViewer,
            60000
        );
    }


    function stopHeartbeat() {
        if (heartbeat) {
            clearInterval(heartbeat);
            heartbeat = null;
        }
    }

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            stopHeartbeat();
        } else {
            startHeartbeat();
        }
    });

    // Start when page loads.
    startHeartbeat();

})();